export function DeckDirectionGuide({ compact = false }: { compact?: boolean }) {
  return (
    <aside
      className={`deck-direction-guide ${compact ? "compact" : ""}`}
      role="note"
      aria-label="Richting van de trekstapel"
    >
      <span className="deck-direction-edge top" data-deck-edge="top">
        <b>BOVENKANT</b>
        <small>Hier trek je de volgende kaart</small>
      </span>
      <span className="deck-direction-stack" aria-hidden="true"><i /><i /><i /><em>stapel</em></span>
      <span className="deck-direction-edge bottom" data-deck-edge="bottom">
        <b>ONDERKANT</b>
        <small>Hier leg je een kaart terug</small>
      </span>
    </aside>
  );
}

export function deckPositionLabel(indexFromTop: number, total: number): string {
  if (total <= 1) return "BOVENKANT én ONDERKANT · enige kaart";
  if (indexFromTop === 0) return "BOVENKANT · volgende kaart";
  if (indexFromTop === total - 1) return "ONDERKANT · laatste kaart";
  return `${indexFromTop + 1}e kaart vanaf boven`;
}
